import { Select, Skeleton } from 'antd';
import API from 'API';
import React, { useCallback, useEffect, useState } from 'react'

export default function BasicInfo({ course, setCourse }) {
    const [courses, setCourses] = useState([]);
    const [gettingCourses, setGettingCourses] = useState(false);
    const [savingRequiredCourses, setSavingRequiredCourses] = useState(false);
    
    const saveRequiredCourses = useCallback(requiredCourses => {
        setSavingRequiredCourses(true);
        API.post("/enroll-required-course/", {
            course_id: course.id,
            required_courses: requiredCourses,
        })
        .then(res => {})
        .catch(error => console.log(error))
        .finally(() => {
            setSavingRequiredCourses(false);
        })
    }, [course.id]);

    useEffect(() => {
        setGettingCourses(true);
        API.get(`/courses/`, { params: { page_size: 10000 } })
        .then(res => {
            setCourses(res.data.results);
        })
        .catch(error => {
            console.log(error)
        })
        .finally(() => {
            setGettingCourses(false);
        })
    }, [])

    return gettingCourses ? <Skeleton active /> 
    : <>
        <div>
            <b>Môn học tiên quyết: </b>
            <Select
                mode="multiple"
                value={course.required_courses}
                options={courses.map((item) => ({ value: item.id, label: item.name }))}
                onChange={(selected) => {
                    if (selected.length < course.required_courses.length) {
                        saveRequiredCourses(selected);
                    }
                    setCourse((prev) => ({ ...prev, required_courses: selected }));
                }}
                onBlur={() => {
                    saveRequiredCourses(course.required_courses);
                }}
                style={{ width: "100%" }}
                optionFilterProp="label"
                loading={savingRequiredCourses}
                disabled={savingRequiredCourses}
            />
        </div>
    </>
}
